import { __ } from '@wordpress/i18n';

import {
	TextControl,
	PanelBody,
	ToggleControl,
	Button,
	ToolbarGroup,
	ToolbarButton,
} from '@wordpress/components';
import {
	InspectorControls,
	BlockControls,
	useBlockProps,
	useInnerBlocksProps,
} from '@wordpress/block-editor';
import { useState } from '@wordpress/element';
import { OptionsModal } from '../form-select/modal';
import Settings from '../form-input/settings';
import classNames from 'classnames';

export default function Edit( props ) {
	const [ isModalOpen, setIsModalOpen ] = useState( false );

	const { attributes } = props;
	const { name, required, options, type } = attributes;

	const blockProps = useBlockProps( {
		className: classNames( {
			'missing-name': ! name,
		} ),
	} );

	const { children, ...innerBlocksProps } = useInnerBlocksProps( blockProps, {
		allowedBlocks: false,
		templateLock: false,
	} );

	return (
		<div { ...innerBlocksProps }>
			<BlockControls>
				<ToolbarGroup>
					<ToolbarButton
						label={ __( 'Edit options', 'formello' ) }
						icon={ 'editor-ul' }
						onClick={ () => {
							setIsModalOpen( true );
						} }
					/>
				</ToolbarGroup>
			</BlockControls>
			<Settings { ...props } />
			{ isModalOpen && (
				<OptionsModal
					{ ...props }
					onRequestClose={ () => {
						setIsModalOpen( false );
					} }
				/>
			) }
			{ options.map( ( opt, index ) => {
				const id = name + '-' + index;
				return (
					<div
						key={ index }
						className={
							'wp-block-popper-form-input is-label-inline'
						}
					>
						<label htmlFor={ id }>{ opt.label }</label>
						<input
							value={ opt.value || opt.label }
							name={ name }
							type={ type }
							required={ required }
							checked={ opt.selected }
							onChange={ () => {} }
							id={ id }
						/>
					</div>
				);
			} ) }
		</div>
	);
}
